import React, { useEffect, useState, useCallback } from "react";
import { Col, Modal, Row, Toast } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getTeamDetails } from "../../modules/Team/teamSlice";
import { Cancel01Icon } from "../../assets/icons";

export default function TeamView({
  show,
  handleClose,
  teamId,
}) {
  const [team, setTeam] = useState(null);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("success");
  const dispatch = useDispatch();

  const fetchTeam = useCallback(async () => {
    try {
      const result = await dispatch(getTeamDetails(teamId));
      setTeam(result.payload.data);
    } catch (error) {
      setSnackbarMessage("Failed to load team details!");
      setSnackbarVariant("danger");
      setShowSnackbar(true);
    }
  }, [dispatch, teamId]);

  useEffect(() => {
    if (teamId && show) {
      fetchTeam();
    }
  }, [teamId, show, fetchTeam]);

  const handleModalClose = useCallback(() => {
    setTeam(null);
    handleClose();
  }, [handleClose]);

  return (
    <>
      <Toast
        onClose={() => setShowSnackbar(false)}
        show={showSnackbar}
        delay={3000}
        autohide
        bg={snackbarVariant}
        style={{ position: "fixed", top: 20, right: 20, zIndex: 1000 }}
      >
        <Toast.Body style={{ color: "white" }}>{snackbarMessage}</Toast.Body>
      </Toast>

      <Modal
        show={show}
        size="lg"
        centered
        dialogClassName="common-popup-dialog"
        contentClassName="common-popup-content"
        backdropClassName="common-popup-backdrop"
        onHide={handleModalClose}
      >
        <Modal.Body className="common-popup-body">
          <div
            className="position-absolute end-0 z-2 bg-white rounded-1 cursor-pointer d-flex align-items-center justify-content-center common-popup-close-btn"
            onClick={handleModalClose}
          >
            <Cancel01Icon width={16} height={16} color="#BCBBC1" strokeWidth="2.5" />
          </div>
          <div className="mb-4 text-center common-popup-heading">
            <h4 className="text-capitalize mb-2 fw-medium">View Team Member</h4>
            <p>Team Member details</p>
          </div>

          {team ? (
            <div>
              <Row>
                <Col md={6} className="mb-4">
                  <strong>Name:</strong>
                  <p>{team.member_name}</p>
                </Col>

                <Col md={6} className="mb-4">
                  <strong>Position</strong>
                  <p>{team.member_position}</p>
                </Col>

                <Col md={6} className="mb-4">
                  <strong>Facebook Link</strong>
                  <p>{team.facebook_link}</p>
                </Col>

                <Col md={6} className="mb-4">
                  <strong>Instagram Link</strong>
                  <p>{team.instagram_link}</p>
                </Col>

                <Col md={6} className="mb-4">
                  <strong>Twitter Link</strong>
                  <p>{team.twitter_link}</p>
                </Col>
              </Row>

              <hr></hr>

              {/* Display Image */}
              {team.member_image && (
                <div className="mb-4">
                  <strong>Member Image:</strong>
                  <div className="mt-3">
                    <img src={team.member_image} alt="Team Member" className="img-fluid" height={"150px"} width={"150px"} />
                  </div>
                </div>
              )}
            </div>
          ) : (
            <p>Loading team member details...</p>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}
